import React from "react";
import "./auth.scss";
import RegistrationForm from "../../components/Forms/AuthForms/RegistrationForm";
import onco_mark from "../../assets/logos/ONCOEVIDA_1.png";

const Registration = () => {
  return (
    <div className="myCustomLogin">
      <div className="logoPart container">
        <div className="logoContainer">
          <img src={onco_mark} alt="" style={{ width: "50%" }} />
        </div>
        <h2 className="form-header mt-2">Welcome to OncoEvida</h2>
        <div className="formPart">
          <div className="contact">
            <RegistrationForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Registration;
